export default {"src":"/_next/static/media/alliance_mobile.bb10dd71.svg","height":31,"width":330,"blurWidth":0,"blurHeight":0};